import { cn } from "@/lib/utils";

/**
 * Shared atmospheric layer for marketing/product pages.
 * Pure decoration — no layout impact, pointer-events none.
 * SSOT for ambient orbs/grid/horizon (do not re-inline markup).
 */
export function PageAmbient({
  intensity = "medium",
  className,
}: {
  intensity?: "soft" | "medium" | "strong";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "page-ambient",
        intensity === "medium" && "page-ambient--medium",
        intensity === "soft" && "opacity-50",
        intensity === "strong" && "opacity-90",
        className
      )}
      aria-hidden="true"
      data-testid="page-ambient"
    >
      <div className="page-ambient-orb page-ambient-orb--a" />
      <div className="page-ambient-orb page-ambient-orb--b" />
      <div className="page-ambient-grid" />
      <div className="page-ambient-horizon" />
    </div>
  );
}
